<template>
  <div>
    <meu-menu> </meu-menu>
    <b-container fluid class="adjustment-margin container-margin-top">
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="breadcrumb">
                Você esta na Àrea - {{ area_nome }}, confira as vagas disponíveis
                abaixo.
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    <!--
    <b-row class="p-3 d-none d-md-block">
      <b-col>
        <div class="mb-3">
          <b-button-group>
            <b-button variant="outline-primary" @click="ordemNome" size="sm"
              ><font-awesome-icon icon="sort" />
              Ordenar por Nome
            </b-button>
          </b-button-group>
        </div>
      </b-col>
    </b-row>-->

   <b-row class="search-row-wrapper d-none d-md-block">
        <b-col class="search-adjustment-margin">
          <div class="search-bar">
            <b-input-group>
              <tooltip
                desc="Digite o nome ou código de uma vaga."
                variant="info"
                cWidth="10"
                cHeight="10"
              ></tooltip>
              <b-form-input
                v-model="search"
                placeholder="Digite uma vaga..."
                id="search-input"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="getPesquisa(search)" variant="success">
                  Pesquisar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
      </b-row>


    <!-- Pesquisa Celular -->

      <b-row class="d-md-none mb-3">
        <b-col class="adjustment-margin-mobile" cols="12">
          <div>
            <b-input-group>
              <b-form-input
                v-model="search"
                placeholder="Digite uma vaga..."
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="success" @click="getPesquisa(search)">
                  Pesquisar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
      </b-row>


    <!-- Card Desktop -->
    <div class="d-none d-md-block">
        <b-row class="flexList">
          <b-col
            cols="6"
            lg="6"
            sm="12"
            v-for="rows in this.vagas"
            :key="rows.id"
            class="customCardHeight"
          >
            <div @click="mudar(rows)" class="card-cv adjustment-margin">
              <b-row>
                <b-col>
                  <h5 class="titulo-vagas">
                    {{ (rows.nome || "") | truncate(40) }}
                  </h5>
                  <h6 class="subtitulo-vagas">
                    Código: <span class="text-primary">{{ rows.codigo }}</span>
                    , Vagas Disponíveis:
                    <span class="text-danger">{{ rows.numero_vagas }}</span>
                  </h6>
                  <b-button
                    variant="success"
                    size="sm"
                    @click="mudar(rows)"
                    class="mt-3 button-vagas"
                    >Ver Mais Detalhes</b-button
                  >
                  <hr />
                  <p class="subtitulo-vagas sub-size">Descrição da vaga:</p>
                  <p class="texto-vagas" v-html="rows.atribuicoes"></p>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
    </div>

    

    <b-row class="d-md-none">
      <b-col cols="12" v-for="rows in this.vagas" :key="rows.id">
        <div class="mb-4">
          <b-card @click="mudar(rows)" class="card-vagas-celular">
            <b-row>
              <b-col>
                <span class="codigo-vaga">{{ rows.codigo }}</span>
                <br />
                <span class="titulo-vagas">{{
                  (rows.nome || "") | truncate(40)
                }}</span>
                <br />
                <span
                  >Vagas Disponíveis
                  <b-badge variant="danger">{{
                    rows.numero_vagas
                  }}</b-badge></span
                >
                <hr />
                <span class="codigo-vaga">Descrição da Vaga</span>
                <br />
                <span
                  class="descricao-vaga"
                  :inner-html.prop="rows.atribuicoes | truncate(250)"
                >
                </span>
                <br />
                <b-button
                  variant="success"
                  size="sm"
                  @click="mudar(rows)"
                  class="mt-3"
                >
                  Ver Mais Detalhes
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-col>
    </b-row>

    <!-- Paginador -->
      <b-row class="paginatorWrapper">
        <b-col>
          <div class="adjustment-margin">
            <b-pagination
              v-model="currentPage"
              :total-rows="this.total"
              :per-page="perPage"
              align="center"
              pills
              size="lg"
              hide-goto-end-buttons
              aria-controls="my-table"
              @input="getData(currentPage)"
              class="page-item-margin"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>

  </b-container>
</div>
</template>

<script>
import { sharedService } from "../../services";
import Menu from "../shared/Menu";

export default {
  data() {
    return {
      vagas: [],
      areas: [],
      perPage: 6,
      total: 0,
      currentPage: 1,
      area_id: "",
      area_nome: "",
      ordenarData: false,
      ordenarNome: false,
      usuarioDados: "",
      search: "",
      pesquisa: "",
    };
  },
  components: {
    "meu-menu": Menu,
  },
  created() {
    if (this.$route.params.nome) {
      this.area_id = this.$route.params.nome.id;
      this.area_nome = this.$route.params.nome.titulo;
      this.getData();
    }
  },
  methods: {
    detalhesVaga(item) {
      this.pesquisa = "";
      this.search = "";
      this.area_id = item.id;
      this.area_nome = item.titulo;
      this.getData();
    },
    getPesquisa(item) {
      this.pesquisa = item;
      this.getData();
    },
    voltar() {
      this.$router.push({
        name: "ultimas",
      });
    },
    mudar(item) {
      this.$router.push({
        name: "vagas_detalhe",
        params: { vaga: item },
      });
    },
    ordemData() {
      this.ordenarNome = false;
      this.ordenarData = true;
      this.getData();
    },
    ordemNome() {
      this.ordenarData = false;
      this.ordenarNome = true;
      this.getData();
    },
    getData: async function (pageNum) {
      let self = this;

      if (pageNum === undefined) {
        pageNum = 1;
      }
      if (
        self.area_id == "" ||
        self.area_id === undefined ||
        self.area_id === null
      ) {
        self.area_id = "-1";
      }

      if (this.ordenarNome === true) {
        await sharedService
          .read(
            "VagasAbertas/" +
              this.$store.getters.getApiKey +
              "?limit=" +
              self.perPage +
              "&page=" +
              pageNum +
              '&order=nome%20asc&filtros=[["cargoarea_id", "=", "' +
              self.area_id +
              '"]]'
          )
          .then(function (obj) {
            self.vagas = obj.obj;
            self.currentPage = obj.page;
            self.total = parseInt(obj.total_records, 0);
          });
      } else if (this.ordenarData === true) {
        await sharedService
          .read(
            "VagasAbertas/" +
              this.$store.getters.getApiKey +
              "?limit=" +
              self.perPage +
              "&page=" +
              pageNum +
              '&order=data_vaga%20desc&filtros=[["cargoarea_id", "=", "' +
              self.area_id +
              '"]]'
          )
          .then(function (obj) {
            self.vagas = obj.obj;
            self.currentPage = obj.page;
            self.total = parseInt(obj.total_records, 0);
          });
      } else if (this.pesquisa !== "") {
        await sharedService
          .read(
            "VagasAbertas/" +
              this.$store.getters.getApiKey +
              "?limit=" +
              self.perPage +
              "&page=" +
              pageNum +
              '&filtros=[["cargoarea_id", "=", "' +
              self.area_id +
              '"]]&search=' +
              this.pesquisa
          )
          .then(function (obj) {
            self.vagas = obj.obj;
            self.currentPage = obj.page;
            self.total = parseInt(obj.total_records, 0);
          });
      } else {
        await sharedService
          .read(
            "VagasAbertas/" +
              this.$store.getters.getApiKey +
              "?limit=" +
              self.perPage +
              "&page=" +
              pageNum +
              '&filtros=[["cargoarea_id", "=", "' +
              self.area_id +
              '"]]'
          )
          .then(function (obj) {
            self.vagas = obj.obj;
            self.currentPage = obj.page;
            self.total = parseInt(obj.total_records, 0);
          });
      }
    },
  },
  watch: {
    user: function () {
      if (this.user.id !== 0) {
        this.usuarioDados = this.user;
      }
    },
    search: function (val) {
      if (val == "") {
        self.pesquisa = "";
        self.getData();
      }
    },
  },
};
</script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style>
.titulo-vagas {
  color: var(--card-title-color);
  font-weight: bold;
  line-height: 1.2;
  text-transform: uppercase;
  text-align: center;
  font-size: 2rem;
  margin-top: 1ch;
  margin-bottom: 0.7rem;
}

.subtitulo-vagas {
  color: var(--card-subtitle-color);
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
}

.sub-size {
  font-size: 1.2rem;
}

.button-vagas {
  display: block;
  margin: 0.4rem auto;
  font-size: 1.1rem;
  padding: 0.3rem 0.5rem;
}

.texto-vagas {
  color: var(--card-dark-text-color);
  text-align: left;
  padding: 1.4ch 3ch 1ch 3ch;
  font-size: 1.2rem;
}

.descricao-vaga {
  font-size: 13px;
  color: #5e5e5e;
}

.flexList {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.flexSearchBox {
  /* width: 100vw; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 0;
}

.customCardHeight {
  min-width: 55vw;
  max-width: 70vw;
  height: 35vh;
}

.paginatorWrapper {
  width: 25vw;
  margin: 0 auto;
}
.page-item-margin li {
  margin-left: 2ch;
  margin-right: 2ch;
}

.card-main {
  border-radius: 15px;
  margin-top: 4ch;
}

.container-margin-top {
  margin-top: 1ch;
}

.search-adjustment-margin {
  margin-top: 3ch;
}

.search-bar {
  min-width: 50vw;
  max-width: 70vw;
  margin: 0 auto;
}
</style>
